import { Box, styled } from '@mui/material';

export const BaseGuardContainer = styled(Box, { name: 'BaseGuardContainer' })({
  marginTop: '10%',
});
